export interface AdditionalDocumentations {
  isMultipleOfferForm?: boolean;
  waiverOfCoolingOff?: WaiverOfCoolingOff;
}

export interface WaiverOfCoolingOff {
  coolingOffCondition?: CoolingOffCondition;
  shortenCoolingOffDays?: number;
}

export enum CoolingOffCondition {
  IncludeShorteningOfCoolingOff = 'IncludeShorteningOfCoolingOff',
  IncludeWaiverOfCoolingOff = 'IncludeWaiverOfCoolingOff',
}
